import React from 'react'
import { Badge, Typography } from 'antd'

const { Text } = Typography

interface CampaignSelectorProps {
  selectedCampaignIds: string[]
  selectedCampaignNames: Record<string, string>
  className?: string
  title?: string
  emptyMessage?: string
}

export const CampaignSelector: React.FC<CampaignSelectorProps> = ({
  selectedCampaignIds,
  selectedCampaignNames,
  className = '',
  title = 'Selected Campaigns:',
  emptyMessage = 'Please select campaigns from the table below'
}) => {
  const renderCampaignDisplay = () => {
    if (selectedCampaignIds.length === 0) {
      return <Text type="secondary">{emptyMessage}</Text>
    }
    
    if (selectedCampaignIds.length > 5) {
      return (
        <div className="flex items-center gap-2">
          <Badge count={selectedCampaignIds.length} color="blue" />
          <Text type="secondary">campaigns selected</Text>
        </div>
      )
    }
    
    return (
      <div className="flex flex-wrap gap-2">
        {selectedCampaignIds.map(id => (
          <Badge key={id} color="blue" text={selectedCampaignNames[id] || id} />
        ))}
      </div>
    )
  }

  return (
    <div className={className}>
      <Text strong>{title}</Text>
      <div className="mt-2">
        {renderCampaignDisplay()}
      </div>
    </div>
  )
}
